import React, { useRef } from "react";
import { motion, useInView } from "framer-motion";

// Data for causes with associated images
const causeData = [
  {
    id: 1,
    name: "Medical",
    image: "https://static.vecteezy.com/system/resources/thumbnails/006/966/135/small/medicine-doctor-holding-red-heart-shape-in-hand-with-medical-icon-network-connection-modern-virtual-screen-interface-service-mind-and-medical-technology-network-concept-photo.jpg",
  },
  {
    id: 2,
    name: "Memorial",
    image: "https://upload.wikimedia.org/wikipedia/commons/1/17/National_War_Memorial_on_the_21st_anniversary_of_Kargil_Vijay_Diwas%2C_2020.jpg",
  },
  {
    id: 3,
    name: "Children",
    image: "https://media.istockphoto.com/id/507276910/photo/group-of-happy-gypsy-indian-children-desert-village-india.jpg?s=612x612&w=0&k=20&c=IacakE5fqzC6w6Vs7MShhZFKa4ZV2_yupL5cfKxKVQg=",
  },
  {
    id: 4,
    name: "Education",
    image: "https://media.istockphoto.com/id/1170754176/photo/indian-school-children-in-classroom.jpg?s=612x612&w=0&k=20&c=A8O3FTFVWOxmwZrpz_R9GUBjAHWqDEsl68x_aNYPuRU=",
  },
  {
    id: 5,
    name: "Animal",
    image: "https://images.unsplash.com/photo-1610349406712-d1c71803c936?fm=jpg&q=60&w=3000&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8aW5kaWFuJTIwZG9nc3xlbnwwfHwwfHx8MA%3D%3D",
  },
  {
    id: 6,
    name: "Others",
    image: "https://img.freepik.com/free-photo/volunteer-giving-box-with-donations-another-volunteer_23-2149230558.jpg",
  },
];

// Framer Motion variants for animation
const cardVariants = {
  hidden: { opacity: 0, y: 50 },
  visible: { opacity: 1, y: 0, transition: { duration: 2.5 } }, // Slow down the transition
};

const Cause = () => {
  const sectionRef = useRef(null);
  const isInView = useInView(sectionRef, { once: true });

  return (
    <div className="mt-12">
      <motion.h2 className="text-4xl font-bold text-center mb-10 text-gray-800" ref={sectionRef}>
        Causes You Can Raise Funds For
      </motion.h2>
      <p className="text-center mb-6">
        Be it for a personal need, social cause, or a creative idea - you can count on us for the project that you want to raise funds for.
      </p>
      <ul className="grid md:grid-cols-3 gap-8">
        {causeData.map(({ id, name, image }) => (
          <motion.li
            whileHover={{scale:1.05}}
            transition={{delay:0.1}}
            key={id}
            className="relative bg-black p-1 h-52 shadow-md rounded-md text-center font-semibold hover:scale-105 hover:shadow-xl transition-all duration-300 ease-in-out cursor-pointer"
            variants={cardVariants}
            initial="hidden"
            animate={isInView ? "visible" : "hidden"} // Trigger animation only when in view
          >
            {/* Image background */}
            <div
              className="absolute inset-0 bg-cover bg-center rounded-md opacity-70 "
              style={{ backgroundImage: `url(${image})` }}
            ></div>

            <div className="relative z-10">
              <h3 className="text-lg font-bold text-white">{name}</h3>
            </div>
          </motion.li>
        ))}
      </ul>
    </div>
  );
};

export default Cause;
